import { jsx } from "react/jsx-runtime";
import MapIcon from "@mui/icons-material/Map";
import { validateTidalLicense } from "../../base/index.js";
function Map(props) {
  return /* @__PURE__ */ jsx(
    MapIcon,
    {
      "data-testid": "Map",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Map",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
Map.tidalIconMeta = {
  categories: "map,location,time",
  name: "Map"
};
validateTidalLicense();
export {
  Map
};
//# sourceMappingURL=Map.js.map
